import { logEvent } from 'firebase/analytics';
import { analytics } from './config';

// Service pour gérer les analytics
export const analyticsService = {
  // Tracer une soumission de formulaire
  trackFormSubmission(source, formData) {
    try {
      if (analytics) {
        logEvent(analytics, 'form_submit', {
          form_name: source,
          user_email: formData.email ? 'provided' : 'not_provided',
          user_phone: formData.phone ? 'provided' : 'not_provided',
          service_requested: formData.service || 'not_specified'
        });
      }
    } catch (error) {
      console.error('Erreur analytics:', error);
    }
  },

  // Tracer un clic sur un bouton
  trackButtonClick(buttonName, location) {
    try {
      if (analytics) {
        logEvent(analytics, 'button_click', {
          button_name: buttonName,
          location: location
        });
      }
    } catch (error) {
      console.error('Erreur analytics:', error);
    }
  },

  // Tracer une visite de page
  trackPageView(pageName) {
    try {
      if (analytics) {
        logEvent(analytics, 'page_view', {
          page_name: pageName
        });
      }
    } catch (error) {
      console.error('Erreur analytics:', error);
    }
  },

  // Tracer un appel téléphonique
  trackPhoneCall(phoneNumber) {
    try {
      if (analytics) {
        logEvent(analytics, 'phone_call', {
          phone_number: phoneNumber
        });
      }
    } catch (error) {
      console.error('Erreur analytics:', error);
    }
  },

  // Tracer un envoi d'email
  trackEmailSend(emailAddress) {
    try {
      if (analytics) {
        logEvent(analytics, 'email_send', {
          email_address: emailAddress
        });
      }
    } catch (error) {
      console.error('Erreur analytics:', error);
    }
  }
};
